import styled from "@emotion/styled";

export const Wrapper = styled.div`
    text-align: center !important;
`;
